import { ProgressionResult } from '@flatsy/utils/Functions/Files/GetApplicationDossierProgression/Type'

export interface stepProgressionProps {
  progression: ProgressionResult
}
export type stepProgressionReturn = [
  'incomming' | 'inprogress' | 'completed',
  'incomming' | 'inprogress' | 'completed',
  'incomming' | 'inprogress' | 'completed'
]

export const stepProgression = ({ progression }: stepProgressionProps): stepProgressionReturn => {
  const steps: stepProgressionReturn = ['inprogress', 'incomming', 'incomming']
  if (progression.complete === true) {
    steps[0] = 'completed'
    steps[1] = 'inprogress'
  }
  return steps
}
